<ng-container>
  <mat-form-field class="mat-block" [ngClass]="{'l-updated-field': isOverriden}">
    <mat-select id="ddShortDate" [formControl]="ctrlShortDate" [placeholder]="placeholder" required>
      <mat-option *ngFor="let shortDate of shortDateList" [value]="shortDate"
        >{{shortDate.format}}</mat-option
      >
    </mat-select>
    <mat-error
      id="errShortDate"
      class="error-message"
      *ngIf="(ctrlShortDate.dirty ||ctrlShortDate.touched)"
    >
      {{ "organization.create.section_3.short_date_required" | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
